$base-size: 2rem;
$bund-blue: #356799;

@mixin list-item {
    a {
        outline: none;
        color: #000;
        display: block;
        text-indent: 5rem;
        position: relative;
        text-decoration: none;
        padding-right: calc($base-size / 2);
        max-width: 100%;
        border-radius: 3px;
        
        span {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
        }


        // when active show underline if href set
        &[href] {
            &:focus-visible {
                outline: 2px dashed $bund-blue;
            }

            &:hover, &:focus, &:active {
                 text-decoration: underline;
            }

            &::before {
                background-color: #8494A4;
            }
            &:hover, &:active {
                  &::before {
                    background-color: #20487B;
                }
            } 
        }

        // numbers
        &::before {
            box-sizing: border-box;
            counter-increment: menuitem; 
            content: counter(menuitem); 
            background-color: #20487B;      
            font-size: $base-size;                
            color: #fff;
            text-indent: 0;
            border-radius: 3px;
            width: $base-size * 1.6;
            height: $base-size * 1.6;
            display: inline-block;
            margin-right: 10px;
            text-align: center;
            padding-top: 1px;
            position: absolute;
            left: 0;
        }

        // connecting lines
        &::after {
            content: ''; 
            background-color: #8494A4;
            height: 1.5rem;
            width: 2px;
            position: absolute;
            display: block;
            bottom: -1em;
            left: 0.7em;
        }
    }                                
    
    &:last-child a::after {
        display: none;
    } 
}

@mixin collapsed-item {
    pointer-events: none;
    height: 1px;
    margin: 0;
    position: absolute;
    
    &:before {
        display: none;
    }
    &:after {
        display: none;
    }

    a {
        pointer-events: none;
        &:after {
            display: none;
        }
    }
}

@mixin expand-trigger {
    border-radius: 50%;
    width: 30px;
    margin-left: 3px;
    cursor: pointer;

    &:focus-visible {
        outline: 2px dashed $bund-blue;
    }

    &:before {
        display: block;
        content: '';
        position: absolute;
        border-color: rgba(0,0,0,0) $bund-blue;
        border-radius: 50%;
        border-style: solid;
        border-width: 2px;
        height: 20px;
        width: 20px;
        top: 3.5px;
        left: 3px;
        transform: rotate(117deg);
        transition: background-color, transform 0.5s ease-in-out;
    }
    &:hover::before {
        border-color: rgba(0,0,0,0) #20487B;
        transform: rotate(207deg);
    }
    &:after {
        display: block;
        content: '+';
        position: absolute;
        color: $bund-blue;
        font-size: 2rem;
        left: 10px;    
        top: 0px;
    }
    &:hover::after {
        color: #20487B;
    }
    a {
        left: 50px;
        position: static;
        height: 30px;

        &:before {
           height: 1px;
           width: 1px;
           left: 7px;
           opacity: 0.2;
           overflow: hidden;
        }

        &:after {
            left: 13px;
        }

        span {
            display: block;
            height: 1px;
            width: 1px;
            overflow: hidden;
        }

    }  
}



:host {   
       
    padding-left: 50px;
    $aside-width: 300px;
    max-width: $aside-width;
    line-height: 1.5;

    @media (max-width: 767px) {        
        max-width: 100%;
        padding-left: 0;
        overflow: hidden;     
    }  

    font-family: 'Fira Sans', sans-serif;

    nav {
        $container-width: 895px;
        background-color: #F2F4F6;
        @media (min-width: 1024px) and (max-width: 1440px) {        
            width: calc(((100vw - #{$container-width}) / 2) + #{$aside-width} - 40px);    
        } 

        @media (min-width: 1440px) {        
            width: calc(((100vw - 1200px) / 2) + 450px - 40px);    
        } 
        
        @media (min-width: 768px) and (max-width: 1023px) {        
            width: calc(#{$aside-width} + 38px);    
        } 

        @media (max-width: 767px) {        
            width: 100%;     
        }  

        margin-top: 0;
        padding: 20px;

        header {
            display: block;
            font-size: 2.5rem;
            padding-bottom: 4rem;

            h4 {
                margin-bottom: 0;
            }

            button {
                appearance: none;
                border: 0;
                background: none;
                color: $bund-blue;
                font-family: 'Fira Sans', sans-serif;
                text-decoration: underline;
                font-size: 1.5rem;
                padding: 0;
                outline: none;
                outline-offset: 4px;
                border-radius: 3px;
                cursor: pointer;

                &:focus-visible {
                    outline: 2px dashed $bund-blue;
                }

                &:hover {
                    text-decoration: none;
                }
            }
        }

        ol {        
            margin-top: 0;
            counter-reset: menuitem;        
            font-size: $base-size * 1.1;                
            padding: 0;
    
            li {
                display: block;
                margin-bottom: 3rem;
                position: relative;
                max-width: 100%;

                * {
                    white-space: nowrap;
                }

                @include list-item();

                &.collapsed {
                    @include expand-trigger();
                }

                &.collapsed + .collapsed {
                    @include collapsed-item();
                }
            } 
        }
    }
  
}
